"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDicts = exports.getDict = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _auth = require("@/utils/auth");
var _dataTypeOf = require("./data/data-type-of");
var _isEmpty = require("./data/is-empty");
// import wlUtils, { dataTypeOf, isEmpty } from './index'

// console.log('asb', wlUtils)

/** 获取 字典请求方法
 * @description: 字典的获取方法主体，原始方法。
 * @param { String | Array } dictsKey 字典key值，只能是一个字符串
 * @return { Array } 返回查询出来的字典
 */
var getDictList = function getDictList(dictsKey) {
  var d = [];
  if (Array.isArray(dictsKey)) d = dictsKey;else if (typeof dictsKey === 'string') d = dictsKey.split(',');
  return new Promise(function (resolve, reject) {
    var url = require('@/settings.js').dictUrl;
    if (!url) {
      reject(new Error('请先在根目录下 settings.js 文件中设置 dictUrl（字典请求地址）'));
    }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url + '?dictTypes=' + d.join(','), false);
    xhr.setRequestHeader('Authorization', 'Bearer ' + (0, _auth.getToken)());
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onreadystatechange = function () {
      // readyState == 4说明请求已完成
      if (xhr.readyState === 4 && xhr.status === 200 || xhr.status === 304) {
        // 从服务器获得数据
        if (xhr.responseText) {
          // 请求返回体
          var res = JSON.parse(xhr.responseText);
          // 字典列表
          var dicts = res.data
          /* 处理字典数据对象 */.map(function (dict) {
            return dict.map(function (item) {
              return Object.assign(item, {
                label: item.dictLabel,
                value: item.dictValue
              });
            });
          });
          var a = {};
          d.forEach(function (dict, index) {
            a[dict] = dicts[index];
          });
          resolve(a);
          var oldDictJson = sessionStorage.getItem('dicts');
          var oldDicts = {};
          if (oldDictJson) oldDicts = JSON.parse(oldDictJson);
          Object.assign(oldDicts, a);
          sessionStorage.setItem('dicts', JSON.stringify(oldDicts));
        }
      } else {
        reject(xhr);
      }
    };
    xhr.send();
  });
};

/** 获取单个字典
  * @description: 获取单个字典
  * @param { String } dicts 字典key值，只能是一个字符串
  * @param { Boolean } refresh 是否需要最新字典？默认：false, true的话就会发送字典请求，false优先从本地缓存中查找
  * @return { Array } 返回查询出来的字典数组
  */
var getDict = exports.getDict = function getDict(dicts) {
  var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var d = '';
  switch ((0, _dataTypeOf.dataTypeOf)(dicts)) {
    case 'string':
      d = dicts;
      break;
    default:
      // eslint-disable-next-line no-console
      console.warn('警告，获取单个字典\n\t输入内容不是字符串');
      break;
  }
  if (!refresh) {
    var dictJson = sessionStorage.getItem('dicts');
    var a = {};
    if (dictJson) a = JSON.parse(dictJson);
    if (a[d]) return a[d];
    getDictList(d);
    return [];
  } else {
    return new Promise(function (resolve, reject) {
      getDictList(d).then(function (dict) {
        resolve(dict[d]);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

/** 批量获取字典
  * @description: 批量获取字典
  * @param { Array | String } dicts 字典key值，可以是一个数组，也可以是一个 逗号分割的字符串
  * @param { Boolean } refresh 是否需要最新字典？默认：false, true的话就会发送字典请求，false优先从本地缓存中查找
  * @return { Object } 返回查询出来的字典，对象key对应指定的字典key value，为这个字典的内容
  */
var getDicts = exports.getDicts = function getDicts(dicts) {
  var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // const a = new
  var d = [];
  var b = {};
  switch ((0, _dataTypeOf.dataTypeOf)(dicts)) {
    case 'string':
      d = dicts.split(',');
      break;
    case 'array':
      d = dicts;
      break;
    default:
      // eslint-disable-next-line no-console
      console.warn('警告，批量获取字典\n\t输入内容并不是数组 或者 逗号分割的字符串');
      break;
  }

  // eslint-disable-next-line no-console
  if (d.length === 0) console.warn('警告，批量获取字典\n\t要获取的字典key为空');
  if (!refresh) {
    var dictJson = sessionStorage.getItem('dicts');
    var a = {};
    if (dictJson) a = JSON.parse(dictJson);
    d.forEach(function (dictKey) {
      b[dictKey] = a[dictKey];
    });
    var e = [];
    // eslint-disable-next-line no-unused-vars
    for (var dictKey in b) {
      if ((0, _isEmpty.isEmpty)(b[dictKey])) {
        e.push(dictKey);
      }
    }
    if (e.length > 0) this.getDictList(d);
    return b;
  } else {
    return new Promise(function (resolve, reject) {
      getDictList(d).then(function (dict) {
        resolve(dict);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};